<template>
  <div>
    <div
      v-if="view!='home'"
      class="refonte_back-home"
      @click="goHome()"
      style="cursor:pointer;margin-top:20px;margin-bottom:20px"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="20" height="20">
        <path d="M199.7 299.8C189.4 312.4 190.2 330.9 201.9 342.6L329.9 470.6C339.1 479.8 352.8 482.5 364.8 477.5C376.8 472.5 384.6 460.9 384.6 447.9L384.6 191.9C384.6 179 376.8 167.3 364.8 162.3C352.8 157.3 339.1 160.1 329.9 169.2L201.9 297.2L199.7 299.6z"/>
      </svg>
      <p>{{ $t("components.pageMenu.btnBackToHome") }}</p>
    </div>

    <div class="refonte_action-buttons" style="display:flex;gap:20px;align-items:center">
      <button v-if="view=='home'" class="refonte_btn-primary" @click="commencer()">
        <svg width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.85156 19.4004C2.27344 19.7736 1.54688 19.786 0.957031 19.4373C0.367188 19.0887 0 18.4324 0 17.7188V3.28127C0 2.56759 0.367188 1.91134 0.957031 1.56271C1.54688 1.21408 2.27344 1.23049 2.85156 1.59963L14.1016 8.81837C14.6602 9.17521 15 9.81095 15 10.5C15 11.1891 14.6602 11.8207 14.1016 12.1817L2.85156 19.4004Z" fill="white"/>
        </svg>
        <span>Commencer</span>
      </button>

      <button class="refonte_btn-secondary" @click="$bvModal.show('save')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 17H17V14L22 18.5L17 23V20H13V17ZM14 12.8C13.5 12.31 12.78 12 12 12C10.34 12 9 13.34 9 15C9 16.31 9.84 17.41 11 17.82C11.07 15.67 12.27 13.8 14 12.8ZM11.09 19H5V5H16.17L19 7.83V12.35C19.75 12.61 20.42 13 21 13.54V7L17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H11.81C11.46 20.39 11.21 19.72 11.09 19ZM6 10H15V6H6V10Z" fill="currentColor"/>
        </svg>
        <span>{{ $t("components.pageMenu.btnSave") }}</span>
      </button>

      <button v-if="somethingToPrint" class="refonte_btn-secondary" @click="$bvModal.show('print')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"/></svg>{{ $t("components.pageMenu.btnPrint") }}
      </button>
    </div>

    <p class="refonte_section-title">{{ $t('components.pageMenu.title') }}</p>

    <ul class="options-links">
      <li class="box-link ressources-sub-footer" @click="$bvModal.show('howTo')" style="cursor:pointer">
        <svg class="icon" viewBox="3.5 0 22 20" xmlns="http://www.w3.org/2000/svg">
          <path class="circle" d="M14.5 0.5C20.02 0.5 24.5 4.97 24.5 10.5C24.5 16.02 20.02 20.5 14.5 20.5C8.97 20.5 4.5 16.02 4.5 10.5C4.5 4.97 8.97 0.5 14.5 0.5Z" fill="none" stroke-width="1" fill-rule="nonzero" stroke-linejoin="round"/>
          <path class="arrow" d="M13.25 6.75L17 10.5L13.25 14.25" fill="none" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round" />
        </svg>
        <p>{{ $t("components.pageMenu.btnHowto") }}</p>
      </li>

      <li class="box-link ressources-sub-footer" @click="downloadManual()" style="cursor:pointer">
      <span class="download-icon">
        <svg class="download-svg" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="path-1-inside-1_4222_10263" fill="white">
            <path d="M8.07227 12.088L4.02769 8.04457L4.83684 7.22171L7.50084 9.88571V0H8.64369V9.88571L11.3066 7.22286L12.1168 8.04457L8.07227 12.088ZM1.91912 16C1.39265 16 0.953408 15.824 0.601408 15.472C0.249408 15.12 0.0730275 14.6804 0.0722656 14.1531V11.384H1.21512V14.1531C1.21512 14.3291 1.28827 14.4907 1.43455 14.6377C1.58084 14.7848 1.74198 14.8579 1.91798 14.8571H14.2266C14.4018 14.8571 14.5629 14.784 14.71 14.6377C14.857 14.4914 14.9302 14.3299 14.9294 14.1531V11.384H16.0723V14.1531C16.0723 14.6796 15.8963 15.1189 15.5443 15.4709C15.1923 15.8229 14.7526 15.9992 14.2254 16H1.91912Z"></path>
          </mask>
          <path d="M8.07227 12.088L4.02769 8.04457L4.83684 7.22171L7.50084 9.88571V0H8.64369V9.88571L11.3066 7.22286L12.1168 8.04457L8.07227 12.088ZM1.91912 16C1.39265 16 0.953408 15.824 0.601408 15.472C0.249408 15.12 0.0730275 14.6804 0.0722656 14.1531V11.384H1.21512V14.1531C1.21512 14.3291 1.28827 14.4907 1.43455 14.6377C1.58084 14.7848 1.74198 14.8579 1.91798 14.8571H14.2266C14.4018 14.8571 14.5629 14.784 14.71 14.6377C14.857 14.4914 14.9302 14.3299 14.9294 14.1531V11.384H16.0723V14.1531C16.0723 14.6796 15.8963 15.1189 15.5443 15.4709C15.1923 15.8229 14.7526 15.9992 14.2254 16H1.91912Z" fill="#EC6726"></path>
          <path d="M8.07227 12.088L7.01176 13.1488L8.07227 14.209L9.13278 13.1488L8.07227 12.088ZM4.02769 8.04457L2.95816 6.99286L1.9151 8.0536L2.96718 9.10538L4.02769 8.04457ZM4.83684 7.22171L5.8975 6.16105L4.82789 5.09144L3.7673 6.17L4.83684 7.22171ZM7.50084 9.88571L6.44018 10.9464L9.00084 13.507V9.88571H7.50084ZM7.50084 0V-1.5H6.00084V0H7.50084ZM8.64369 0H10.1437V-1.5H8.64369V0ZM8.64369 9.88571H7.14369V13.507L9.70435 10.9464L8.64369 9.88571ZM11.3066 7.22286L12.3746 6.16965L11.314 5.09408L10.2459 6.1622L11.3066 7.22286ZM12.1168 8.04457L13.1773 9.10538L14.2309 8.05212L13.1849 6.99136L12.1168 8.04457ZM0.0722656 14.1531H-1.42774L-1.42773 14.1553L0.0722656 14.1531ZM0.0722656 11.384V9.884H-1.42773V11.384H0.0722656ZM1.21512 11.384H2.71512V9.884H1.21512V11.384ZM1.91798 14.8571V13.3571L1.91149 13.3572L1.91798 14.8571ZM14.9294 14.1531H13.4294L13.4294 14.1596L14.9294 14.1531ZM14.9294 11.384V9.884H13.4294V11.384H14.9294ZM16.0723 11.384H17.5723V9.884H16.0723V11.384ZM14.2254 16V17.5L14.2276 17.5L14.2254 16ZM9.13278 11.0272L5.08821 6.98376L2.96718 9.10538L7.01176 13.1488L9.13278 11.0272ZM5.09723 9.09628L5.90637 8.27343L3.7673 6.17L2.95816 6.99286L5.09723 9.09628ZM3.77618 8.28238L6.44018 10.9464L8.5615 8.82505L5.8975 6.16105L3.77618 8.28238ZM9.00084 9.88571V0H6.00084V9.88571H9.00084ZM7.50084 1.5H8.64369V-1.5H7.50084V1.5ZM7.14369 0V9.88571H10.1437V0H7.14369ZM9.70435 10.9464L12.3672 8.28352L10.2459 6.1622L7.58303 8.82505L9.70435 10.9464ZM10.2385 8.27606L11.0488 9.09778L13.1849 6.99136L12.3746 6.16965L10.2385 8.27606ZM11.0563 6.98376L7.01176 11.0272L9.13278 13.1488L13.1773 9.10538L11.0563 6.98376ZM1.91912 14.5C1.76502 14.5 1.71526 14.4645 1.66207 14.4113L-0.459252 16.5327C0.191553 17.1835 1.02027 17.5 1.91912 17.5V14.5ZM1.66207 14.4113C1.60874 14.358 1.57249 14.3072 1.57226 14.151L-1.42773 14.1553C-1.42643 15.0536 -1.10993 15.882 -0.459252 16.5327L1.66207 14.4113ZM1.57227 14.1531V11.384H-1.42773V14.1531H1.57227ZM0.0722656 12.884H1.21512V9.884H0.0722656V12.884ZM-0.284877 11.384V14.1531H2.71512V11.384H-0.284877ZM-0.284877 14.1531C-0.284877 14.7958 -0.00108061 15.3215 0.37114 15.6956L2.49796 13.5798C2.53019 13.6122 2.58764 13.6798 2.63641 13.7875C2.68719 13.8997 2.71512 14.0261 2.71512 14.1531H-0.284877ZM0.37114 15.6956C0.746025 16.0725 1.27584 16.3599 1.92447 16.3571L1.91149 13.3572C2.04075 13.3566 2.17005 13.3848 2.2851 13.437C2.39552 13.4871 2.46474 13.5464 2.49796 13.5798L0.37114 15.6956ZM1.91798 16.3571H14.2266V13.3571H1.91798V16.3571ZM14.2266 16.3571C14.8702 16.3571 15.3952 16.0719 15.7679 15.7011L13.6521 13.5743C13.6839 13.5426 13.7512 13.4853 13.8589 13.4364C13.971 13.3855 14.0982 13.3571 14.2266 13.3571V16.3571ZM15.7679 15.7011C16.1462 15.3248 16.4322 14.7943 16.4294 14.1467L13.4294 14.1596C13.4289 14.0317 13.4566 13.9031 13.5087 13.7881C13.5587 13.6776 13.6181 13.6081 13.6521 13.5743L15.7679 15.7011ZM16.4294 14.1531V11.384H13.4294V14.1531H16.4294ZM14.9294 12.884H16.0723V9.884H14.9294V12.884ZM14.5723 11.384V14.1531H17.5723V11.384H14.5723ZM14.5723 14.1531C14.5723 14.3072 14.5368 14.357 14.4836 14.4102L16.6049 16.5315C17.2557 15.8807 17.5723 15.052 17.5723 14.1531H14.5723ZM14.4836 14.4102C14.4303 14.4635 14.3795 14.4998 14.2232 14.5L14.2276 17.5C15.1258 17.4987 15.9542 17.1822 16.6049 16.5315L14.4836 14.4102ZM14.2254 14.5H1.91912V17.5H14.2254V14.5Z" fill="#EC6726" mask="url(#path-1-inside-1_4222_10263)"></path>
        </svg>
      </span>
      <p>{{ $t("components.pageMenu.btnDownload.title") }}</p>
      </li>
    </ul>

  </div>
</template>

<script>
import PrinterIcon from "vue-material-design-icons/Printer.vue";
import ContentSaveIcon from "vue-material-design-icons/ContentSave.vue";
import HelpCircleIcon from "vue-material-design-icons/HelpCircle.vue";
import HomeIcon from "vue-material-design-icons/Home.vue";
import DownloadNetworkIcon from "vue-material-design-icons/DownloadNetwork.vue";

export default {
  name: "PageMenu",
  components: {
    PrinterIcon,
    ContentSaveIcon,
    HelpCircleIcon,
    HomeIcon,
    DownloadNetworkIcon
  },
  props: {
    view: String
  },
  computed: {
    somethingToPrint: function() {
      return this.$store.state.appState.compagnyCompleted;
    }
  },
  methods: {
    goHome: function() {
      this.$emit("changeview", { view: "home" });
    },
    commencer: function() {
      this.$emit("changeview", { view: "compagny" });
    },
    downloadManual:function() {
        window.open(this.$t("components.pageMenu.btnDownload.href"),"_blank");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../sass/_variables.sass"
@import "../sass/_media.sass"

.defaultButton
  width: 100%
  margin: 0.5em auto
  text-align: left
  padding: 0.5em 1.2em
  font-size: 1.1em
  font-weight: bold

  @include md 
    height: 40px

button
  span
    line-height: 1

.options-box
  text-align: left
  background-color: $lightgray-3
  border: none
  border-radius: 0
  margin: 1em 0
  width: 280px

  .card-title
    font-family: pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
    font-size: 1.846153846em
    color: $gray-1
    padding-top: 10px
    text-transform: uppercase
  
  .card-body
    padding: 1.25em 

@media (max-width: 767px)
  .refonte_action-buttons
    flex-direction: column
    align-items: stretch

    button
      width: 100%
      justify-content: center

.refonte_back-home
  display: flex
  align-items: center
  gap: 6px

  svg
    fill: #4C4C50
    transition: fill 0.2s

  p
    margin-bottom: unset
    font-weight: 700
    font-size: 1.38rem
    color: #161616
    transition: color 0.2s, text-decoration-color 0.2s

  &:hover p
    text-decoration: underline
    text-decoration-color: #E85D2B

  &:active svg
    fill: #CA5413

  &:active p
    color: #CA5413

.options-links
  list-style: none
  padding: 0
  margin: 0
  display: flex
  flex-direction: column
  gap: 10px

  .download-icon
    height: 20px
    width: 20px
    text-align: center

    .download-svg
      height: 16px
      width: 16px
      flex-shrink: 0
      transition: transform 0.2s ease

  li:hover .download-svg
    transform: scale(1.2)

.box-link
  gap: 10px
  display: inline-flex
  position: relative
  left: auto
  text-align: left
  align-items: center

  svg
    width: 20px
    height: 20px
    padding-left: 0px
    align-self: end

    .circle
      fill: none
      stroke: var(--color-orange-inrs)
      transition: fill 0.2s, stroke 0.2s

    .arrow
      fill: none
      stroke: var(--color-orange-inrs)
      transition: stroke 0.2s

  &:hover svg .circle
    fill: var(--color-orange-burnt)
    stroke: var(--color-orange-burnt)

  &:hover svg .arrow
    stroke: #FFFFFF
    fill: var(--color-orange-inrs)

  &:hover p
    color: #8a8a8e
    transition: color 0.2s

  p
    color: #161616
    font-size: 1.38rem
    font-weight: 700
    line-height: 100%
    text-align: left
    margin-bottom: unset
</style>
